import { Component, Input, OnInit } from '@angular/core';
import { ProgressRingComponent } from '../progress-ring/progress-ring.component';

@Component({
  standalone: true,
  selector: 'ct-lib-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  imports: [ProgressRingComponent],
  host: {
    '[style.width.px]': 'size',
    '[style.height.px]': 'size',
  },
})
export class SpinnerComponent implements OnInit {
  @Input() color: string;
  /**
   * Optional outer size in pixels.
   * When unset, defaults to 50px via CSS (parent styles can still override).
   */
  @Input() size: number | null = null;

  ngOnInit(): void {}
}
